import { render, staticRenderFns } from "./edit_account.vue?vue&type=template&id=4b8c232c&scoped=true&"
import script from "./edit_account.vue?vue&type=script&lang=js&"
export * from "./edit_account.vue?vue&type=script&lang=js&"
import style0 from "./edit_account.vue?vue&type=style&index=0&id=4b8c232c&lang=scss&scoped=true&"
import style1 from "./edit_account.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8c232c",
  null
  
)

export default component.exports